// @ts-check

import "./parse.config";
import "antd/dist/reset.css";

import { init, StorageAdapterLS } from "@opendash/core";
import { registerIconPack } from "@opendash/icons";
import Parse from "parse";

import { $parse, ParsePlugin } from "@opendash/plugin-parse";

import { translate } from "@opendash/i18n";
import { AdminRoute } from "./components/AdminRoute";
import { AnalyticsAdminRoute } from "./components/AnalyticsAdminRoute";
import { AnalyticsSharePublicRoute } from "./components/AnalyticsSharePublicRoute";
import { GlossaryAdminRoute } from "./components/GlossaryAdminRoute";
import { ImportReferenceRoute } from "./components/ImportReferenceRoute";
import { InvoiceAdminRoute } from "./components/InvoiceAdminRoute";
import { InvoiceEditAdminRoute } from "./components/InvoiceEditAdminRoute";
import { TenantConfigRoute } from "./components/TenantConfigRoute";
import { VideoAdminRoute } from "./components/VideoAdminRoute";
import { fields as tenantConfigFields } from "./components/TenantConfigRoute";

init("opendash", async (factory) => {
  // Set document title
  try {
    window.document.title = "ASEW Rechnungserklärer Administration";
  } catch (error) {}

  // Logo:
  // Check
  let a = "Init";
  console.log(a);
  factory.ui.setLogoImage(require("../assets/logo.png"));

  // Icons
  // @ts-ignore
  registerIconPack(await import("@opendash/icons/dist/asew-default.json"));

  // @ts-ignore
  registerIconPack(await import("@opendash/icons/dist/fa-regular.json"));

  // Translations:
  factory.registerLanguage("en", "English");
  factory.registerLanguage("de", "Deutsch", "en", true);

  factory.registerTranslationResolver(
    "en",
    "app",
    () => import("./translations/en/app.json")
  );

  factory.registerTranslationResolver(
    "en",
    "parse-custom",
    () => import("./translations/en/parse-custom.json")
  );

  factory.registerAntDesignTranslation(
    "en",
    () => import("antd/lib/locale/en_US")
  );

  factory.registerTranslationResolver(
    "de",
    "app",
    () => import("./translations/de/app.json")
  );

  factory.registerTranslationResolver(
    "de",
    "parse-custom",
    () => import("./translations/de/parse-custom.json")
  );

  factory.registerAntDesignTranslation(
    "de",
    () => import("antd/lib/locale/de_DE")
  );

  // Adapter + Plugins

  factory.registerDeviceStorageAdapter(new StorageAdapterLS());

  factory.ui.disableFooter();

  await factory.use(
    new ParsePlugin({
      authLdapActive: false,
      useLiveQueries: false,
      createAccount: true,
      lostPassword: false,
      usePagination: 100,
      disableNavigationItems: true,
      disableNavigationWidgetPreset: true,
      disableNavigationNotificationSettings: true,
    })
  );
  //await factory.use(new ParseAdminPlugin(ParseAdminConfig));

  // Routes

  factory.registerRoute({
    path: "/admin/rechnungserklaerer",
    component: async () => ({ default: AdminRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/import",
    component: async () => ({ default: ImportReferenceRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/config-appearance",
    component: async () => ({ default: TenantConfigRoute }),
    props: {
      type: "appearance",
    },
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/config-navigation",
    component: async () => ({ default: TenantConfigRoute }),
    props: {
      type: "navigation",
    },
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/config-contact",
    component: async () => ({ default: TenantConfigRoute }),
    props: {
      type: "contact",
    },
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/invoice",
    component: async () => ({ default: InvoiceAdminRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/invoice/:invoiceId",
    component: async () => ({ default: InvoiceEditAdminRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/glossary",
    component: async () => ({ default: GlossaryAdminRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/video",
    component: async () => ({ default: VideoAdminRoute }),
  });

  factory.registerRoute({
    path: "/admin/rechnungserklaerer/analytics",
    component: async () => ({ default: AnalyticsAdminRoute }),
    headerSourcePicker: false,
  });

  factory.registerRoute({
    path: "/analytics-share",
    auth: "both",
    component: async () => ({ default: AnalyticsSharePublicRoute }),
  });

  factory.registerStaticNavigationGroup({
    id: "app/admin",
    label: "app:admin.title",
    order: 5,
  });

  factory.registerStaticNavigationItem({
    id: "admin/rechnungserklaerer/analytics",
    group: "app/admin",
    place: "sidebar",
    order: 50,
    label: "app:admin.analytics.title",
    icon: "fa:chart-line",
    link: "/admin/rechnungserklaerer/analytics",
    routeCondition: "/admin/**",
    activeCondition: "/admin/rechnungserklaerer/analytics",
    // od-admins sehen den Punkt immer. Tenant-Admins nur, wenn ihr Stadtwerk
    // dafür freigeschaltet ist — dann entfällt die Permission-Einschränkung.
    permission: (await tenantMaySeeAnalytics()) ? undefined : "od-admin",
  });

  const tenantConfigFieldsFlat = Object.values(tenantConfigFields).flat();

  $parse.ui.setClassConfig({
    className: "_User",
    titleFields: ["username"],
    displayFields: ["name", "username", "email", "tenant", "tenantAdmin"],
    createFields: [
      "name",
      "username",
      "email",
      "tenant",
      "tenantAdmin",
      "password",
    ],
    editFields: [
      "name",
      "username",
      "email",
      "tenant",
      "tenantAdmin",
      "password",
    ],
    disableACLEditing: true,
  });

  $parse.ui.setClassConfig({
    className: "APP_Language",
    titleFields: ["label"],
    displayFields: ["label"],
    createFields: ["label"],
    editFields: ["label"],
    disableACLEditing: true,
  });
  $parse.ui.setClassConfig({
    className: "OD3_Tenant",
    titleFields: ["label"],
    displayFields: ["label", "tenantConfig"],
    createFields: ["label"],
    editFields: ["label"],
    disableACLEditing: true,
  });
  $parse.ui.setClassConfig({
    className: "APP_TenantConfig",
    titleFields: [],
    displayFields: tenantConfigFieldsFlat,
    createFields: tenantConfigFieldsFlat,
    editFields: tenantConfigFieldsFlat,
    disableACLEditing: true,
    fileValidation: {
      logo: {
        image: true,
        mimeTypes: ["image/jpeg", "image/png", "image/svg+xml"],
        maxFileSize: 1024 * 1024 * 2,
      },
      contactImage: {
        image: true,
        mimeTypes: ["image/jpeg", "image/png", "image/svg+xml"],
        maxFileSize: 1024 * 1024 * 2,
      },
      frontpageBackgroundImage: {
        image: true,
        mimeTypes: ["image/jpeg", "image/png", "image/svg+xml"],
        maxFileSize: 1024 * 1024 * 2,
      },
    },
  });
  $parse.ui.setClassConfig({
    className: "APP_TenantDomain",
    titleFields: ["domain"],
    displayFields: ["tenant", "domain"],
    createFields: ["tenant", "domain"],
    editFields: ["tenant", "domain"],
    disableACLEditing: true,
  });

  $parse.ui.setDefaultView("APP_TenantDomain", {
    type: "table",
  });

  $parse.ui.setClassConfig({
    className: "APP_Invoice",
    titleFields: ["title"],
    displayFields: ["title"],
    createFields: ["title", "icon", "description"],
    editFields: ["title", "icon", "description"],
    disableACLEditing: true,
  });
  $parse.ui.setClassConfig({
    className: "APP_InvoicePage",
    titleFields: ["title"],
    displayFields: ["title", "description", "image"],
    createFields: ["title", "description", "image"],
    editFields: ["title", "description", "image"],
    disableACLEditing: true,
  });
  $parse.ui.setClassConfig({
    className: "APP_GlossaryEntry",
    titleFields: ["title"],
    displayFields: ["language", "title", "text"],
    createFields: ["language", "title", "text"],
    editFields: ["language", "title", "text"],
    disableACLEditing: true,
  });
  $parse.ui.setClassConfig({
    className: "APP_Video",
    titleFields: ["title"],
    displayFields: [
      "language",
      "title",
      "description",
      "draft",
      "video",
      "image",
      "text",
    ],
    createFields: [
      "language",
      "title",
      "description",
      "draft",
      "image",
      "video",
      "text",
    ],
    editFields: [
      "language",
      "title",
      "description",
      "draft",
      "image",
      "video",
      "text",
    ],
    disableACLEditing: true,
    fileValidation: {
      image: {
        image: true,
        mimeTypes: ["image/jpeg"],
        maxFileSize: 1024 * 1024 * 1,
      },
      video: {
        image: true,
        mimeTypes: ["video/mp4"],
        maxFileSize: 1024 * 1024 * 100,
      },
    },
  });
}).then(async (app) => {
  // TODO: workaround to preload translation file
  await translate("parse-admin:admin.delete.action");
});

/**
 * Darf der aktuell angemeldete Tenant-Admin die Auswertung im Menü sehen?
 *
 * Wird beim App-Start ausgewertet. Das ist zuverlässig, weil opendash nach dem
 * Login ein window.location.reload() macht — die Session steht hier also fest.
 *
 * Nur für die Anzeige des Menüpunkts. Die verbindliche Prüfung passiert
 * serverseitig in der Cloud Function analyticsGetData.
 */
async function tenantMaySeeAnalytics(): Promise<boolean> {
  try {
    const user = await Parse.User.currentAsync();
    if (!user || user.get("tenantAdmin") !== true) return false;

    const tenant = user.get("tenant");
    if (!tenant) return false;

    const config = await new Parse.Query("APP_TenantConfig")
      .equalTo("tenant", tenant)
      .first();

    return config?.get("analyticsVisibleForTenant") === true;
  } catch (error) {
    // Darf den App-Start nicht verhindern — im Zweifel kein Menüpunkt.
    console.error("Analytics-Sichtbarkeit konnte nicht geprüft werden:", error);
    return false;
  }
}
